import React, { useState, useEffect,useRef } from 'react';
import { Menu, X, Phone, Mail, Clock, Wrench,Scissors, Home, AlertCircle, Zap, Star, Award, Shield, Calculator, Search,Truck, ArrowLeft, Package, CloudRain, ChevronRight, ArrowRight, Users, Building, CheckCircle, TrendingUp, ChevronLeft, Grid, List, ShoppingCart, HardHat, PaintBucket, Droplets, Thermometer, Layers, Send, Calendar, DollarSign, Bath, Target, Hammer, Handshake, Cpu, Microscope, Quote, MapPin} from 'lucide-react';

import { Trabajo, Producto, Servicio, PhoneNumber } from '../types';

// ==================== COMPONENTE CONSENTIMIENTO DE COOKIES ====================
export default function CookieConsent({ onAccept, onReject, onConfigure, navigateToPage }: { onAccept: () => void; onReject: () => void; onConfigure: () => void; navigateToPage: (page: string) => void }) {
  return (
    <div 
      role="dialog" 
      aria-modal="true" 
      aria-labelledby="cookie-title"
      aria-describedby="cookie-desc"
      className="fixed inset-0 bg-black/60 backdrop-blur-xs flex items-center justify-center z-50 p-4"
    >
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full border border-gray-100 overflow-hidden">
        <div className="p-6">
          <div className="text-center mb-6">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Shield className="w-8 h-8 text-blue-600" aria-hidden="true" />
            </div>
            <h3 id="cookie-title" className="text-xl font-bold text-gray-900 mb-2">Política de Cookies</h3>
            <p id="cookie-desc" className="text-gray-600 text-sm leading-relaxed">
              Utilizamos cookies propias y de terceros para mejorar tu experiencia en nuestro sitio web y analizar el tráfico. 
              Puedes aceptar todas las cookies, rechazar las no necesarias o configurar tus preferencias.
            </p>
          </div>

          <div className="space-y-3">
            <button
              onClick={onAccept}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 px-4 rounded-xl font-bold transition-all shadow-lg shadow-blue-500/20 hover:shadow-blue-500/30 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              Aceptar todas las cookies
            </button>
            <button
              onClick={onReject}
              className="w-full bg-gray-100 hover:bg-gray-200 text-gray-800 py-3 px-4 rounded-xl font-semibold transition-all focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-offset-2"
            >
              Rechazar cookies no necesarias
            </button>
            <button
              onClick={onConfigure}
              className="w-full border border-gray-300 hover:border-gray-400 text-gray-700 py-3 px-4 rounded-xl font-semibold transition-all focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              Configurar preferencias
            </button>
          </div>

          <div className="mt-4 text-center">
            <button 
              onClick={() => navigateToPage('cookies')}
              className="text-blue-600 hover:text-blue-800 text-sm font-medium underline focus:outline-none focus:ring-2 focus:ring-blue-500 rounded px-1"
            >
              Más información sobre cookies
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
